"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./Pivot"), exports);
var PivotItem_1 = require("./PivotItem");
exports.PivotItem = PivotItem_1.PivotItem;
tslib_1.__exportStar(require("./Pivot.Props"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Pivot/index.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Pivot/index.js
// module chunks = 1